import React from "react";
import { FormSubSections, ProgramContainer } from "src/entities/formTemplateDataType";
import { SubSectionComponent } from "../SubSectionComponent";
import { parseJson, stringifyJson } from "../../utilities/JsonUtils";

interface Props {
  programContainer: ProgramContainer;
  isEng:boolean
}

interface State {

}

export class SummaryComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);
   
  }

  render() {
    let ReviewHtmlString=[];
    const programContainer = parseJson(stringifyJson(this.props.programContainer, this.props.programContainer.CategoryId), this.props.programContainer.CategoryId) as ProgramContainer;
      
    programContainer.ListOfFormSections.filter(p => p.Visible)
        .forEach(section => {
            section.ListOfFormSubSections
                .forEach((subSection: FormSubSections) => {
                    const elementsWithoutLabelField = subSection.ListOfFormSectionElements.filter(p => p.Datatype != 'Label' && p.Datatype !== 'Picture' && p.Datatype !== 'HTML' && p.Datatype != 'Button' && p.Datatype!='SuccessAlert' && p.Datatype!='ErrorAlert' && p.Datatype!='InformationAlert');
                    if (elementsWithoutLabelField.length > 0) {
                        subSection.ListOfFormSectionElements = elementsWithoutLabelField;
                        ReviewHtmlString.push(
                            <div key={"summary_" + subSection.Id }>
                                <span className="ontario-h4">{this.props.isEng ? section.ENUTitle : section.FRATitle}</span>
                                <SubSectionComponent
                                    key={'review_DetailComponent_' + section.Id}
                                    isEng={this.props.isEng}  {...this.props}
                                    activeSubSection={subSection}
                                    // renderHeader={programContainer.displayForm !== 'NoIndicatorStepper'}
                                    editable={false}
                                    user={null}
                                    topEntity={{}}
                                    roleBasedEditable={false}
                                    roleBased={false}
                                    callback={(e)=>null}
                                    ownerEditableOnly={false} />
                            </div>
                        )
                    }

                })
        });

    return ReviewHtmlString;

  }

}